const SHOOT_ADDRESS_11436 = [
  {
    label: "大干镇",
    children: [
      "宝山寺大殿",
      "洋门通天大圣祭坛",
      "干仙寮",
      "上湖廊桥",
      "小七台寺遗址",
      "七台山寺遗址",
      "土垅月梯岭古道",
      "土垅古城墙脚",
      "七台山通天大圣祭坛",
      "揽月古台",
    ],
  },
  {
    label: "元坑镇",
    children: [
      "元坑陈氏民居",
      "萧氏三大栋",
      "邓氏宗祠",
      "谟武文苑旧宅",
      "蔡氏宗祠",
      "吴氏宗祠",
      "福峰基督教堂",
      "谟武基督教堂",
      "曲村通天大圣祭坛",
      "登云桥",
      "文昌桥",
      "元坑关帝庙",
      "秀水张氏宗祠",
      "朱氏祠堂",
      "通驷亭",
      "漠布乡农工会旧址",
      "七驺堂",
      "致远堂",
      "福峰三小栋",
      "东郊新庙",
      "东郊戏台",
      "岭干通天大圣祭坛",
      "田公元帅庙",
      "九村圆通寺",
      "曲村张氏宗祠",
      "福峰萧氏宗祠门楼",
      "谟武叶氏宗祠门楼",
      "谟武会龙桥",
      "槎溪桥",
      "际下石拱桥",
      "东郊陈仓标民居",
      "九村范陈和民居",
      "福峰萧帮绪民居",
      "秀水邹金旺民居",
      "秀水陈苍桔民居",
      "东郊陈联桥民居",
      "东郊叶坤兰民居",
      "东郊李有洪民居",
      "九村叶德香民居",
      "五板桥路亭",
      "九村凉亭",
      "九村古道",
      "谟武码头",
      "秀水49号民居",
      "长弄路亭",
      "元坑供销社旧址",
      "谟武村部旧址",
    ],
  },
  {
    label: "双溪街道",
    children: [
      "龙山塔",
      "南津门",
      "白龙泉石拱桥",
      "亨龙塔",
      "庄濠摩崖石刻",
      "亨龙岭摩崖石刻",
      "白龙泉古道",
      "陈板布码头",
    ],
  },
  {
    label: "埔上镇",
    children: [
      "沙口吉祥寺",
      "口前门楼及口前渡口",
      "河墩码头",
    ],
  },
  {
    label: "洋口镇",
    children: [
      "狮峰寺",
      "洋口天后宫",
      "东方军政治部旧址、洋口彭德怀办公旧址、洋口苏维埃政府旧址、洋口毛泽民旧居、项南抗敌剧目演出旧址",
      "光明顺济桥、洋口东方军司令部旧址",
      "中梗码头",
    ],
  },
  {
    label: "建西镇",
    children: [
      "虎山塔",
      "谢坊头通天大圣祭坛",
      "屯山兴隆桥",
      "典義堂",
      "建西林业电影院",
      "谢坊头廊桥",
      "际会知青点",
      "建西贮木场食堂",
      "建西建贮工人俱乐部",
      "元峰公王庙",
      "建西文化娱乐中心",
    ],
  },
  {
    label: "大历镇",
    children: [
      "大山头通天大圣祭坛",
      "范地通天大圣祭坛",
      "大历叶氏宗祠",
      "大历徐氏宗祠",
      "前洋林业铁路桥",
      "丁历石拱桥",
    ],
  },
  {
    label: "仁寿镇",
    children: [
      "海龙桥",
    ],
  },
  {
    label: "郑坊镇",
    children: [
      "云路通天大圣祭坛",
      "榜山通天大圣祭坛",
      "各溪石拱桥",
      "郑坊贞洁牌坊",
    ],
  },
  {
    label: "洋墩乡",
    children: [
      "星亭 含郭岩摩崖石刻、郭岩山水母娘娘洞",
      "郭岩开山祖师塔",
      "郭岩山石塔墓",
      "青云寺僧人塔墓 含郭岩庙遗址、郭岩山炼丹池遗址、郭岩山青云寺井",
      "田溪潘少辉民居",
      "郭源江云乾民居",
      "蔡坑铁门坪门楼",
      "洋坑郭岩山石路亭 含郭岩山古道",
    ],
  },
  {
    label: "岚下乡",
    children: [
      "岐头通天大圣坛庙",
      "黄岩庙",
      "岚下厝桥",
      "铁井栏井",
      "凤科廊桥",
      "外新桥",
      "上玉山槐荫亭",
    ],
  },
  {
    label: "高阳乡",
    children: [
      "兴福寺",
      "北坑云际庵",
      "紫竹双龙庵",
      "花桥步云庵",
      "上村张氏宗祠",
      "牛轭余氏民居",
      "下乾罗德宽民居",
      "上村后山廊桥",
      "下村张公桥",
      "安浆大队礼堂",
      "下乾古道",
      "下乾石拱桥",
    ],
  },
];

const MATCH_CONTRIBUTE_CONFIG = {
  11394: {
    default: {
      extraFields: [
        {
          key: "shoot_time",
          label: "拍摄时间",
          type: "input",
          defaultValue: "",
        },
        {
          key: "shoot_location",
          label: "拍摄地点",
          type: "input",
          defaultValue: "",
        },
        {
          key: "has_ai_assist",
          label: "是否含AI辅助、是否使用他人素材",
          type: "radio",
          defaultValue: 0,
          options: [
            { label: "否", value: 0 },
            { label: "是", value: 1 },
          ],
        },
      ],
    },
    groups: {
      1621: {
        extraFields: [
          {
            key: "shoot_time",
            label: "拍摄时间",
            type: "input",
            defaultValue: "",
          },
          {
            key: "shoot_location",
            label: "拍摄地点",
            type: "input",
            defaultValue: "",
          },
          {
            key: "has_ai_assist",
            label: "是否含AI辅助、是否使用他人素材",
            type: "radio",
            defaultValue: 0,
            options: [
              { label: "否", value: 0 },
              { label: "是", value: 1 },
            ],
          },
          {
            key: "creator_name_and_role",
            label: "创作者的姓名和分工（不超过4人）",
            type: "input",
            defaultValue: "",
          },
        ],
      },
    },
    requirePromise: true,
    promiseText:
      "本人自愿参加本次摄影展赛，已认真阅读并完全知晓本次展赛全部征稿规则、参赛要求及相关说明。本人承诺所提交作品符合法律法规及赛事规定，若存在违反规则、侵犯他人著作权、肖像权等合法权益或弄虚作假等情形，自愿承担由此产生的全部法律责任及相应后果，与主办方、承办方无关。",
  },
  11436: {
    shootAddressOptions: SHOOT_ADDRESS_11436,
  },
};

export function getMatchContributeConfig(matchId, group) {
  const id = Number(matchId);
  if (!id || !MATCH_CONTRIBUTE_CONFIG[id]) {
    return null;
  }
  const matchConfig = MATCH_CONTRIBUTE_CONFIG[id];
  const groupId = Number(group);
  const groupConfig =
    groupId &&
    matchConfig.groups &&
    matchConfig.groups[groupId] &&
    typeof matchConfig.groups[groupId] === "object"
      ? matchConfig.groups[groupId]
      : null;
  const defaultConfig =
    (matchConfig.default && typeof matchConfig.default === "object"
      ? matchConfig.default
      : null) || matchConfig;
  const config = {
    ...matchConfig,
    ...defaultConfig,
    ...(groupConfig || {}),
  };
  return {
    ...config,
    extraFields: (config.extraFields || []).map((field) => ({
      type: "input",
      required: false,
      options: [],
      ...field,
    })),
  };
}

export function applyExtraFieldsDefaults(customFields, config) {
  if (!customFields || !config || !config.extraFields) {
    return customFields;
  }
  config.extraFields.forEach((field) => {
    if (
      typeof customFields[field.key] === "undefined" ||
      customFields[field.key] === null
    ) {
      customFields[field.key] = field.defaultValue;
    }
  });
  return customFields;
}

export function buildExtraFieldsPayload(customFields, config) {
  if (!config || !config.extraFields) {
    return customFields;
  }
  const payload = Array.isArray(customFields)
    ? [...customFields]
    : { ...customFields };
  config.extraFields.forEach((field) => {
    let value = customFields[field.key];
    if (field.type === "checkbox" && typeof value === "boolean") {
      value = value ? 1 : 0;
    }
    payload[field.key] =
      typeof value === "undefined" ? field.defaultValue : value;
  });
  return payload;
}

export function parseShootAddress(value, options) {
  const empty = { level1: "", level2: "" };
  if (!value || !options || !options.length) {
    return empty;
  }
  const text = String(value);
  const sep = " / ";
  const index = text.indexOf(sep);
  if (index < 0) {
    return empty;
  }
  const level1 = text.slice(0, index);
  const level2 = text.slice(index + sep.length);
  const group = options.find((item) => item.label === level1);
  if (!group || group.children.indexOf(level2) === -1) {
    return empty;
  }
  return { level1, level2 };
}

export function formatShootAddress(level1, level2) {
  if (!level1 || !level2) {
    return "";
  }
  return level1 + " / " + level2;
}

export function isCompleteShootAddress(value, options) {
  const parsed = parseShootAddress(value, options);
  return !!(parsed.level1 && parsed.level2);
}
